<div [class.sidebar]="isDialog">
  <div class="dialog-actions">
    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" mat-mini-fab aria-label="Close Sidebar">
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }

    @if (initialized) {
      <button mat-mini-fab (click)="editing = !editing" [disabled]="!editable">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>

  @if (initialized) {
    <form [formGroup]="inputForm">
      <div class="container">
        <!-- title section -->
        <section class="header">
          <div class="title">&nbsp;</div>
        </section>
        <!-- /title section -->
        <nav mat-tab-nav-bar class="sub-nav">
          <a mat-tab-link active="active">Details</a>
          <a mat-tab-link>Members</a>
          <a mat-tab-link>Stations</a>
        </nav>
        <!-- name section -->
        <section>
          <div class="mat-body-2 row">Name:</div>
          @if (!editing) {
            <div class="mat-body">{{site.name}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="text" autocomplete="off" formControlName="name" [errorStateMatcher]="matcher" />
              @if (inputForm.controls.name.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.name.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.name.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /name section -->
        <!-- duration section -->
        <section>
          <div class="mat-body-2 row">Site duration:</div>
          @if (!editing) {
            <div class="mat-body">
              {{site.start_date | dateFormat: "MMMM DD YYYY"}} -
              {{site.end_date | dateFormat: "MMMM DD YYYY"}}
            </div>
          }
          @if (editing) {
            <mat-form-field>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" formControlName="start_date" />
                <input matEndDate placeholder="End date" formControlName="end_date" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker [calendarHeaderComponent]="calendarHeader"></mat-date-range-picker>
              @if (inputForm.controls.end_date.hasError('required') || inputForm.controls.start_date.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /duration section -->
        <!-- site value section -->
        <section>
          <div class="mat-body-2 row">Site value:</div>
          @if (!editing) {
            <div class="mat-body">{{site.site_value}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="number" autocomplete="off" formControlName="site_value" [errorStateMatcher]="matcher" />
              @if (inputForm.controls.site_value.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.site_value.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.site_value.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /site value section -->
        <!-- description section -->
        <section>
          <div class="mat-body-2 row">Description:</div>
          @if (!editing) {
            <div class="mat-body">{{site.description}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <textarea matInput formControlName="description" [errorStateMatcher]="matcher"></textarea>
              @if (inputForm.controls.description.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.description.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.description.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /description section -->
        <!-- location section -->
        <section>
          <div class="mat-body-2">Location:</div>
          @if (!site.latitude || !site.longitude) {
            <div class="input-placeholder" (click)="editLocation(site)">
              <button mat-icon-button [disabled]="!editing" color="accent">
                <mat-icon>location_on</mat-icon>
              </button>Add Location
            </div>
          }
          @if (site.latitude) {
            <div (click)="editLocation(site)">
              <app-location-picker
                [isDialog]="false"
                [latitude]="site.latitude"
                [longitude]="site.longitude"
                height="100px"
              [readOnly]="true"></app-location-picker>
            </div>
          }
          <mat-form-field style="display: none;">
            <input matInput type="number" autocomplete="off" formControlName="latitude"
              [errorStateMatcher]="matcher" />
          </mat-form-field>
          <mat-form-field style="display: none;">
            <input matInput type="number" autocomplete="off" formControlName="longitude"
              [errorStateMatcher]="matcher" />
          </mat-form-field>
          @if (inputForm.controls.latitude.hasError('error') || inputForm.controls.longitude.hasError('error')) {
            <mat-error>
              {{inputForm.controls.latitude.errors.error}}
            </mat-error>
          }
        </section>
        <!-- /location section -->
        <!-- Form Actions -->
        <section>
          @if (editing) {
            <div class="row">
              <button [disabled]="!editable" mat-stroked-button color="accent" (click)="onSubmit()">
                @if (site.id) {
                  Update
                }
                @if (!site.id) {
                  Create
                }
              </button>
              <button mat-stroked-button (click)="onCancel()">Cancel</button>
            </div>
          }
        </section>
        <!-- Form Actions -->
      </div>
    </form>
  }

</div>
